<template>
    <li v-bind:class="['mygrid', 'list-complete-item', {'blink':log_item.blink}]" v-on:animationend="log_item.blink = false">
        <span class="two">
            <a class="refresh" v-if="log_item.status === 'idle'" href="#" v-on:click="updateStatus(log_item)"><refresh-cw-icon></refresh-cw-icon></a>
            <a class="refresh rotating" v-else href="#"><refresh-cw-icon></refresh-cw-icon></a>
            {{log_item.id}}
            <a target="_blank" :href="log_item.URL">{{log_item.URL}}<external-link-icon></external-link-icon></a>
            <copy-link v-bind:text-to-copy="log_item.URL"></copy-link>
        </span>
        <template>
            <span class="one cent">{{log_item.reason}}</span>
            <span class="one cent">{{log_item.type}}</span>
            <span class="one cent">/{{log_item.regex}}/</span>
            <span class="two"><strong>{{log_item.description}}</strong></span>
        </template>
    </li>
</template>

<script>
    import CopyLink from "@/components/UI/_base-UI-CopyLink";
    import { RefreshCwIcon, ExternalLinkIcon } from 'vue-feather-icons'

    export default {
        name: "MonitoringRow",
        components:{
            CopyLink,
            RefreshCwIcon,
            ExternalLinkIcon
        },
        props:{
            log_item: Object,
            updateStatus: Function,
            copyURL: Function
        }
    }
</script>

<style scoped>
    #linkList ul li.mygrid {
        display: grid;
        grid-template-columns: 2fr 0.5fr 0.5fr 1fr 4fr;
        background: #dfdfdf;
        box-shadow: 0px 0px 0px #fff2a9;
    }

    #linkList ul li.blink{
        animation: blink 1000ms ease 0s 1;
        animation-fill-mode: forwards;
    }

    #linkList ul li.blink span a svg{

    }

    @keyframes blink {
        0%{
            padding: 0.5rem;
            box-shadow: none;
            background-color: #dfdfdf;
            border-left: 1px solid #888;
            border-top: 1px solid #ffffff;
        }

        50%{
            top: -2px;
            box-shadow: inset 0px 0px 3px 1px #ffd89a;
            background-color: #fffdd1;
        }

        100%{
            padding: 0.5rem;
            box-shadow: none;
            background-color: #dfdfdf;
            border-left: 1px solid #888;
            border-top: 1px solid #ffffff;
            border-bottom: 1px solid #888;
        }
    }

    ul li a{
        color: #4e4872;
    }

    ul li span{
        width: 100%;
    }
</style>
